import { render, staticRenderFns } from "./HistoricoObservacao.vue?vue&type=template&id=2e33881e&scoped=true"
import script from "./HistoricoObservacao.vue?vue&type=script&lang=js"
export * from "./HistoricoObservacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoObservacao.vue?vue&type=style&index=0&id=2e33881e&prod&lang=css"
import style1 from "./HistoricoObservacao.vue?vue&type=style&index=1&id=2e33881e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33881e",
  null
  
)

export default component.exports